import { LocalizationService } from "../../ShellCommon/localization/localization";
import { LoggingService } from "../sdServices/loggingSvc";
import { ApplicationContextService } from "../sdServices/context/application-context-service";
import { ServiceDeskConfig } from "../Startup/serviceDeskConfig";
import { ignoreFuturePlsErrorsQueryStringParameter } from "../sdServices/loading/prerequisite-loading-service";

export interface StateParameters {
  errorParams: {
    toState: string;
    toParams: any;
    fromState: string;
    fromParams: any;
    error: any;
  };
}
const serviceDeskAppId = "ServiceDesk";
const errorMessageKey = "_ERROR_PAGE_ERROR_MESSAGE_";
const errorDetailsKey = "_ERROR_PAGE_ERROR_DETAILS_";
const tryAgainMessageKey = "_ERROR_PAGE_TRY_AGAIN_";
export class ErrorController {
  public errorMessageText: string;
  public errorDetailsText: string;
  public traceCodes: string[] = [];
  public tryAgainText: string;
  public errorInfos: string[];
  public showErrors: boolean;

  // @ngInject
  constructor(
    public $stateParams: StateParameters,
    sdLocalizationService: LocalizationService,
    $scope: ng.IScope,
    private $state: angular.ui.IStateService,
    loggingService: LoggingService,
    private $window: ng.IWindowService,
    private applicationContextService: ApplicationContextService,
    private sdConfig: ServiceDeskConfig
  ) {
    sdLocalizationService.whenReady(serviceDeskAppId).finally(() => {
      $scope.$applyAsync(() => {
        this.errorMessageText = sdLocalizationService.getLocalizedString(serviceDeskAppId, errorMessageKey);
        this.errorDetailsText = sdLocalizationService.getLocalizedString(serviceDeskAppId, errorDetailsKey);
        this.tryAgainText = sdLocalizationService.getLocalizedString(serviceDeskAppId, tryAgainMessageKey);
      });
    });

    this.attachErrorContext();

    if ($stateParams.errorParams) {
      this.errorInfos = Object.keys($stateParams.errorParams).map((key) => {
        let value = (<any>$stateParams.errorParams)[key];
        if (typeof value == "object") {
          value = JSON.stringify(value);
        }
        return `${key}: ${value}\r\n`;
      });
      loggingService.logError(
        `Exception occurred while loading route ${$stateParams.errorParams.toState} from ${$stateParams.errorParams.fromState}` +
          ` with parameters ${JSON.stringify($stateParams.errorParams.toParams)}. Error: ${
            $stateParams.errorParams.error
          }`
      );
    }

    if (this.sdConfig.currentEnvironment && this.sdConfig.currentEnvironment != "prod") {
      this.showErrors = true;
    }
  }
  public ignoreErrors() {
    let prefix = this.$window.location.href.includes("?") ? "&" : "?";
    this.$window.location.href = this.$window.location.href.replace(
      "#",
      prefix + ignoreFuturePlsErrorsQueryStringParameter + "=true#"
    );
  }

  private attachErrorContext() {
    let appContext = this.applicationContextService.appContext;
    this.traceCodes.push(`application correlation vector: ${appContext.applicationCV}`);
    this.traceCodes.push(`window correlation vector: ${appContext.windowCV}`);
    this.traceCodes.push(
      `application creation time: ${
        appContext.creationTime && typeof appContext.creationTime.toUTCString !== "undefined"
          ? appContext.creationTime.toUTCString()
          : "Unknown"
      }`
    );
  }

  public copyDetailsToClipboard() {
    angular
      .element("<textarea/>")
      .css({ opacity: "0", position: "fixed" })
      .text(
        JSON.stringify(
          {
            appContext: this.applicationContextService.appContext,
            errorDetails: this.$stateParams.errorParams
          },
          undefined,
          2
        )
      )
      .appendTo(angular.element(this.$window.document.body))
      .select()
      .each(() => document.execCommand("copy"))
      .remove();
  }
}
